export const articles = [
  {
    id: "swift-6-concurrency-preparation",
    title: "Preparing a Large Codebase for Swift 6 Strict Concurrency",
    description: "Strategies for migrating legacy code and adapting to the new, safer concurrency models in Swift 6 without breaking the build.",
    date: "2024-11-10",
    readTime: "7 min read",
    tags: ["Swift 6", "Concurrency", "Architecture"],
    titleTr: "Büyük Bir Kod Tabanını Swift 6 Strict Concurrency'ye Hazırlamak",
    descriptionTr: "Legacy kodu taşıma ve Swift 6'nın daha güvenli concurrency modellerine build'i bozmadan uyum sağlama stratejileri.",
    slug: "swift-6-concurrency-preparation"
  },
  {
    id: "modern-ios-developer-tools-2024",
    title: "The Modern iOS Developer's Toolkit in Late 2024",
    description: "Beyond Xcode: How I integrate formatters, linters, and advanced profiling tools to boost daily productivity.",
    date: "2024-11-24",
    readTime: "6 min read",
    tags: ["Productivity", "Xcode", "Tooling"],
    titleTr: "2024 Sonunda Modern iOS Geliştirici Araç Seti",
    descriptionTr: "Xcode'un ötesi: Günlük verimliliği artırmak için formatter, linter ve gelişmiş profil araçlarını nasıl entegre ediyorum.",
    slug: "modern-ios-developer-tools-2024"
  },
  {
    id: "tuist-dependency-management-large-scale",
    title: "Taming pbxproj Conflicts: Managing Large Codebases with Tuist",
    description: "How generating Xcode projects on the fly with Tuist eliminates merge conflicts and simplifies dependency injection.",
    date: "2024-12-08",
    readTime: "6 min read",
    tags: ["Tuist", "Modular", "CI/CD"],
    titleTr: "pbxproj Çatışmalarını Ehlileştirmek: Tuist ile Büyük Kod Tabanları",
    descriptionTr: "Xcode projelerini anlık üretmenin merge çatışmalarını nasıl ortadan kaldırdığı ve bağımlılık enjeksiyonunu nasıl sadeleştirdiği.",
    slug: "tuist-dependency-management-large-scale"
  },
  {
    id: "viper-in-swiftui-era",
    title: "Is VIPER Still Relevant in the SwiftUI Era?",
    description: "Drawing clean boundaries in enterprise apps. Why strict architectural patterns still matter when using declarative UI.",
    date: "2024-12-22",
    readTime: "6 min read",
    tags: ["VIPER", "SwiftUI", "Clean Code"],
    titleTr: "SwiftUI Çağında VIPER Hâlâ Anlamlı mı?",
    descriptionTr: "Beş rollü, protokol ağırlıklı deseni SwiftUI'ın getirdikleriyle yeniden değerlendirmek: neyi bırakmalı, neyi korumalı.",
    slug: "viper-in-swiftui-era"
  },
  {
    id: "ml-vs-llm-mobile-guide",
    title: "Machine Learning vs. LLMs: A Guide for Mobile Engineers",
    description: "Demystifying AI jargon. Understanding when to use traditional ML models versus Large Language Models on iOS.",
    date: "2025-01-12",
    readTime: "6 min read",
    tags: ["AI", "Core ML", "LLM"],
    titleTr: "Makine Öğrenmesi mi LLM mi: Mobil Mühendisler için Rehber",
    descriptionTr: "Core ML modeli mi eğitmeli yoksa bir bulut API'sine mi gitmeli; cevap performansı, gizliliği ve maliyeti belirliyor.",
    slug: "ml-vs-llm-mobile-guide"
  },
  {
    id: "ai-tools-daily-workflow",
    title: "A New Era of Productivity: AI Tools in My Daily Workflow",
    description: "How I safely integrate Cursor, Claude, and Gemini into my development routine without compromising code security.",
    date: "2025-01-26",
    readTime: "6 min read",
    tags: ["AI", "Cursor", "Productivity"],
    titleTr: "Yeni Bir Verimlilik Çağı: Günlük Akışımdaki AI Araçları",
    descriptionTr: "Cursor, Claude ve Gemini'yi kod güvenliğinden ödün vermeden geliştirme rutinime nasıl entegre ediyorum.",
    slug: "ai-tools-daily-workflow"
  },
  {
    id: "complex-push-notifications-architecture",
    title: "Architecting a Scalable Push Notification System",
    description: "Handling complex push notification payloads, silent pushes, and UI updates in a multi-module iOS application.",
    date: "2025-02-09",
    readTime: "7 min read",
    tags: ["Architecture", "Push Notifications", "iOS"],
    titleTr: "Ölçeklenebilir Bir Push Notification Sistemi Tasarlamak",
    descriptionTr: "Çok modüllü bir iOS uygulamasında karmaşık push payload'larını, sessiz push'ları ve arayüz güncellemelerini yönetmek.",
    slug: "complex-push-notifications-architecture"
  },
  {
    id: "secure-deeplink-infrastructure",
    title: "Building a Secure and Reliable Deeplink Infrastructure",
    description: "Creating a robust routing mechanism that handles dynamic links securely across isolated feature modules.",
    date: "2025-02-23",
    readTime: "7 min read",
    tags: ["Deeplink", "Routing", "Security"],
    titleTr: "Güvenli ve Sağlam Bir Deeplink Altyapısı Kurmak",
    descriptionTr: "İzole feature modülleri arasında dinamik bağlantıları güvenle yöneten sağlam bir yönlendirme mekanizması kurmak.",
    slug: "secure-deeplink-infrastructure"
  },
  {
    id: "analytics-abstraction-wrapper",
    title: "Escaping Analytics Hell: Building a Unified Wrapper",
    description: "How to decouple Firebase, Mixpanel, and Netmera by creating a clean, protocol-oriented analytics abstraction layer.",
    date: "2025-03-09",
    readTime: "7 min read",
    tags: ["Analytics", "Design Patterns", "Mixpanel"],
    titleTr: "Analytics Soyutlama Katmanı",
    descriptionTr: "Firebase ve Mixpanel çağrılarını view'lardan çıkarıp derleme zamanı güvenli bir sözleşmenin arkasına almak.",
    slug: "analytics-abstraction-wrapper"
  },
  {
    id: "time-to-market-indie-apps",
    title: "Time-to-Market: Delivering Niche Apps in Under 2 Months",
    description: "My philosophy on rapid prototyping, leveraging AI design tools, and making the right architectural trade-offs.",
    date: "2025-03-23",
    readTime: "5 min read",
    tags: ["Indie Dev", "Product", "Agile"],
    titleTr: "Indie Uygulamalarda Pazara Çıkış Süresi",
    descriptionTr: "Mükemmel mimari, yayımlanmış uygulamanın düşmanı: sürdürülebilirlikten ödün vermeden hızlı teslim etmek.",
    slug: "time-to-market-indie-apps"
  },
  {
    id: "ios-to-macos-development",
    title: "Bridging the Gap: From iOS to macOS Development",
    description: "Lessons learned while building niche productivity tools for Mac. Understanding AppKit, Catalyst, and macOS SwiftUI differences.",
    date: "2025-04-06",
    readTime: "5 min read",
    tags: ["macOS", "SwiftUI", "Ecosystem"],
    titleTr: "iOS'tan macOS'a Geçmek",
    descriptionTr: "Mac bir klavye takılmış iPad değil: Catalyst, AppKit ve macOS SwiftUI arasında yol bulmak.",
    slug: "ios-to-macos-development"
  },
  {
    id: "apple-ecosystem-dx-future",
    title: "The State of Apple Ecosystem: Where is Developer Experience Heading?",
    description: "An analysis of the current Apple Developer Experience (DX) and predictions for the upcoming WWDC.",
    date: "2025-04-20",
    readTime: "5 min read",
    tags: ["DX", "Apple", "Ecosystem"],
    titleTr: "Apple Ekosisteminde Geliştirici Deneyiminin Geleceği",
    descriptionTr: "Dil ve framework tarafı gelişirken araçların neden geride kaldığı ve neyin değişmesi gerektiği.",
    slug: "apple-ecosystem-dx-future"
  },
  {
    id: "ai-future-of-coding",
    title: "Will AI Replace Us or Make Us Superheroes?",
    description: "A philosophical and technical look at the future of software engineering in the age of advanced LLMs.",
    date: "2025-05-11",
    readTime: "5 min read",
    tags: ["Philosophy", "AI", "Future"],
    titleTr: "AI Bizi Değiştirecek mi, Süper Kahramana mı Çevirecek?",
    descriptionTr: "Gelişmiş LLM'ler çağında yazılım mühendisliğinin geleceğine felsefi ve teknik bir bakış.",
    slug: "ai-future-of-coding"
  },
  {
    id: "swiftui-performance-state-management",
    title: "Mastering SwiftUI Performance and State Management",
    description: "Identifying view redraw bottlenecks and optimizing state flow in complex, data-heavy iOS screens.",
    date: "2025-05-25",
    readTime: "7 min read",
    tags: ["SwiftUI", "Performance", "State Management"],
    titleTr: "SwiftUI Performansı ve State Yönetimi",
    descriptionTr: "Kurumsal bir uygulamada SwiftUI-UIKit sınırında performansı ve state'i, hiçbir şeyi bozmadan yönetmek.",
    slug: "swiftui-performance-state-management"
  },
  {
    id: "wwdc25-apple-intelligence-integration",
    title: "WWDC25 Aftermath: Integrating Apple Intelligence into Mobile Apps",
    description: "A deep dive into the new Natural Language APIs and how to leverage Apple Intelligence for better UX.",
    date: "2025-06-08",
    readTime: "5 min read",
    tags: ["WWDC25", "Apple Intelligence", "AI"],
    titleTr: "WWDC25 Sonrası: Apple Intelligence'ı Mobil Uygulamalara Entegre Etmek",
    descriptionTr: "Yeni Natural Language API'lerine derin bakış ve daha iyi deneyim için Apple Intelligence'tan yararlanmak.",
    slug: "wwdc25-apple-intelligence-integration"
  },
  {
    id: "tuist-multi-target-cicd",
    title: "Multi-Target Management and CI/CD Pipelines with Tuist",
    description: "Automating target creation, managing different environments (Dev/Test/Prod), and streamlining CI workflows.",
    date: "2025-06-22",
    readTime: "7 min read",
    tags: ["Tuist", "CI/CD", "Automation"],
    titleTr: "Tuist ile Çoklu Target Yönetimi ve CI/CD Pipeline'ları",
    descriptionTr: "Target oluşturmayı otomatikleştirmek, farklı ortamları (Dev/Test/Prod) yönetmek ve CI akışlarını sadeleştirmek.",
    slug: "tuist-multi-target-cicd"
  },
  {
    id: "fintech-app-security-ssl-pinning",
    title: "Fintech-Grade Network Security: SSL Pinning & MITM Prevention",
    description: "Implementing robust SSL pinning techniques to protect financial data from Man-in-the-Middle attacks.",
    date: "2025-07-06",
    readTime: "6 min read",
    tags: ["Security", "Fintech", "Network"],
    titleTr: "Fintech Uygulama Güvenliği: SSL Pinning",
    descriptionTr: "HTTPS'in neden yetmediği, public key pinning'in nasıl kurulacağı ve anahtar rotasyonunun nasıl planlanacağı.",
    slug: "fintech-app-security-ssl-pinning"
  },
  {
    id: "app-integrity-jailbreak-checks",
    title: "Ensuring App Integrity: Jailbreak Detection and Anti-Tampering",
    description: "How to implement advanced jailbreak checks and make reverse engineering significantly harder for malicious actors.",
    date: "2025-07-20",
    readTime: "6 min read",
    tags: ["Security", "AppSec", "Jailbreak"],
    titleTr: "Uygulama Bütünlüğü ve Jailbreak Kontrolleri",
    descriptionTr: "Çok katmanlı jailbreak tespiti ve kurcalama önleme; bir de bu savunmaların gerçekte ne kazandırdığı.",
    slug: "app-integrity-jailbreak-checks"
  },
  {
    id: "scalable-cicd-fastlane-jenkins",
    title: "Scalable iOS Deployment: Automating with Fastlane and Jenkins",
    description: "Building a completely automated release train for enterprise iOS applications using Fastlane and Jenkins.",
    date: "2025-08-03",
    readTime: "6 min read",
    tags: ["DevOps", "Fastlane", "Jenkins"],
    titleTr: "Fastlane ve Jenkins ile Ölçeklenebilir CI/CD",
    descriptionTr: "Manuel App Store dağıtımlarından, kod imzalamayı otomatikleştiren bir release trenine geçiş.",
    slug: "scalable-cicd-fastlane-jenkins"
  },
  {
    id: "technical-documentation-large-teams",
    title: "Beyond Code: The Vital Role of Technical Documentation",
    description: "Why maintaining Architectural Decision Records (ADRs) and clear documentation is crucial for large engineering teams.",
    date: "2025-08-17",
    readTime: "6 min read",
    tags: ["Engineering Culture", "Documentation", "Leadership"],
    titleTr: "Koddan Öte: Teknik Dokümantasyonun Kritik Rolü",
    descriptionTr: "Mimari Karar Kayıtlarını (ADR) ve net dokümantasyonu sürdürmenin büyük mühendislik ekipleri için neden hayati olduğu.",
    slug: "technical-documentation-large-teams"
  },
  {
    id: "idea-to-market-app-lifecycle",
    title: "From Idea to Market: The Complete Mobile Product Lifecycle",
    description: "Walking through the entire process of bringing an app to life: ideation, validation, development, and launch.",
    date: "2025-09-07",
    readTime: "6 min read",
    tags: ["Product", "Maker", "Strategy"],
    titleTr: "Fikirden Pazara: Mobil Ürünün Tam Yaşam Döngüsü",
    descriptionTr: "Bir uygulamayı hayata geçirmenin tüm süreci: fikir, doğrulama, geliştirme ve lansman.",
    slug: "idea-to-market-app-lifecycle"
  },
  {
    id: "figma-for-ios-developers",
    title: "Figma for iOS Developers: Bridging the Design-Code Gap",
    description: "How mastering Figma can help engineers extract assets better, understand design systems, and build pixel-perfect UIs.",
    date: "2025-09-21",
    readTime: "7 min read",
    tags: ["UI/UX", "Figma", "Design System"],
    titleTr: "iOS Geliştiriciler için Figma",
    descriptionTr: "Tasarım ve kod arasındaki boşluğu token tabanlı bir mimariyle kapatmak.",
    slug: "figma-for-ios-developers"
  },
  {
    id: "core-ml-on-device-scenarios",
    title: "Real-World On-Device Machine Learning with Core ML",
    description: "Practical scenarios for deploying Core ML models directly on iOS devices to ensure low latency and high privacy.",
    date: "2025-10-05",
    readTime: "6 min read",
    tags: ["Core ML", "Machine Learning", "Privacy"],
    titleTr: "Core ML ile Cihaz Üstü Senaryolar",
    descriptionTr: "Gizlilik öncelikli makine öğrenmesi: belge tarama, OCR ve Apple'ın hazır framework'lerinin yettiği yerler.",
    slug: "core-ml-on-device-scenarios"
  },
  {
    id: "anomaly-detection-fintech-ml",
    title: "Using ML for Anomaly Detection in Financial Applications",
    description: "Leveraging on-device machine learning models as an active security barrier against unusual transaction patterns.",
    date: "2025-10-19",
    readTime: "6 min read",
    tags: ["Security", "Fintech", "Machine Learning"],
    titleTr: "Finansal Uygulamalarda Anomali Tespiti için ML Kullanmak",
    descriptionTr: "Cihaz üstü makine öğrenmesi modellerini, olağandışı işlem örüntülerine karşı aktif bir güvenlik bariyeri olarak kullanmak.",
    slug: "anomaly-detection-fintech-ml"
  },
  {
    id: "open-source-ai-mobile-impact",
    title: "The Impact of Open-Source AI Models on Mobile Development",
    description: "Exploring how the shift towards open-source AI is democratizing advanced capabilities for independent mobile developers.",
    date: "2025-11-02",
    readTime: "6 min read",
    tags: ["Open Source", "AI", "Trends"],
    titleTr: "Açık Kaynak AI Modellerinin Mobil Geliştirmeye Etkisi",
    descriptionTr: "Açık kaynağa kayışın, bağımsız mobil geliştiriciler için gelişmiş yetenekleri nasıl demokratikleştirdiği.",
    slug: "open-source-ai-mobile-impact"
  },
  {
    id: "stitch-data-integration-mobile",
    title: "Accelerating Mobile Backend Connections with Stitch",
    description: "A deep dive into using Stitch for advanced, seamless data integration and synchronization in modern iOS apps.",
    date: "2025-11-16",
    readTime: "6 min read",
    tags: ["Backend", "Stitch", "Data Integration"],
    titleTr: "Stitch ile Mobil Backend Bağlantılarını Hızlandırmak",
    descriptionTr: "Modern iOS uygulamalarında gelişmiş ve sorunsuz veri entegrasyonu ile senkronizasyon için Stitch kullanımına derin bakış.",
    slug: "stitch-data-integration-mobile"
  },
  {
    id: "openclaw-ai-code-analysis",
    title: "Next-Gen Code Quality: Analyzing iOS Projects with OpenClaw",
    description: "How OpenClaw's AI-driven analysis tools are changing the way we review, refactor, and maintain large Swift codebases.",
    date: "2025-12-07",
    readTime: "6 min read",
    tags: ["OpenClaw", "Code Quality", "AI Tooling"],
    titleTr: "OpenClaw ile AI Destekli Kod Analizi",
    descriptionTr: "Statik analizin ötesinde: mimari kusurları ve iş mantığı hatalarını AST üzerinden yakalamak.",
    slug: "openclaw-ai-code-analysis"
  },
  {
    id: "2025-ios-architecture-review",
    title: "2025 in Review: The Evolution of Security, Automation, and AI",
    description: "An architect's retrospective on the biggest shifts in the iOS ecosystem over the past year.",
    date: "2025-12-21",
    readTime: "5 min read",
    tags: ["Retrospective", "Architecture", "Review"],
    titleTr: "2025 iOS Mimari Retrospektifi",
    descriptionTr: "Modülerleşme, istemci tarafı güvenlik ve AI'ın gerçek üretime girişi: yılın üç büyük kayması ve maliyetleri.",
    slug: "2025-ios-architecture-review"
  },
  {
    id: "on-device-vs-cloud-llms",
    title: "On-Device vs. Cloud LLMs: Integrating Open-Source Models Securely",
    description: "Evaluating the trade-offs of running large language models locally on iOS hardware versus relying on cloud APIs.",
    date: "2026-01-11",
    readTime: "6 min read",
    tags: ["LLM", "On-Device AI", "Architecture"],
    titleTr: "Cihaz Üstü mü Bulut LLM mi: Açık Kaynak Modelleri Güvenle Entegre Etmek",
    descriptionTr: "Büyük dil modellerini iOS donanımında yerel çalıştırmakla bulut API'lerine dayanmak arasındaki ödünleşimleri değerlendirmek.",
    slug: "on-device-vs-cloud-llms"
  },
  {
    id: "biometrics-token-security-appsec",
    title: "The Hidden Layer of AppSec: Biometrics and Token Management",
    description: "Advanced techniques for securing user sessions using the Secure Enclave, biometric validation, and token rotation.",
    date: "2026-01-25",
    readTime: "6 min read",
    tags: ["Security", "Biometrics", "AppSec"],
    titleTr: "Biyometri, Token Güvenliği ve AppSec",
    descriptionTr: "Keychain'i doğru kullanmak, Secure Enclave'e bağlı öğeler ve kullanıcıyı dışarıda bırakmadan token rotasyonu.",
    slug: "biometrics-token-security-appsec"
  },
  {
    id: "indie-hacker-marketing-aso",
    title: "App Store Optimization and Marketing for Indie Hackers",
    description: "Technical marketing strategies to increase visibility and downloads for your independent iOS and macOS applications.",
    date: "2026-02-08",
    readTime: "6 min read",
    tags: ["Indie Dev", "ASO", "Marketing"],
    titleTr: "Indie Hacker için ASO ve App Store Rehberi",
    descriptionTr: "40'tan fazla uygulama gönderdikten sonra öğrendiklerim: metadata, gizlilik ve ret sebepleri.",
    slug: "indie-hacker-marketing-aso"
  },
  {
    id: "devsecops-jenkins-sast-pipeline",
    title: "DevSecOps on iOS: Integrating SAST into Jenkins Pipelines",
    description: "How to automatically scan for security vulnerabilities during the CI build process using Static Application Security Testing.",
    date: "2026-02-22",
    readTime: "5 min read",
    tags: ["DevSecOps", "Jenkins", "Security"],
    titleTr: "iOS'ta DevSecOps: Jenkins Pipeline'larına SAST Entegrasyonu",
    descriptionTr: "Güvenlik açıklarını CI build sürecinde otomatik olarak taramak ve PR seviyesinde engellemek.",
    slug: "devsecops-jenkins-sast-pipeline"
  },
  {
    id: "openclaw-stitch-autonomous-clients",
    title: "Building Autonomous Clients with OpenClaw and Stitch",
    description: "Combining intelligent code generation with robust data pipelines to create highly autonomous and connected mobile clients.",
    date: "2026-03-08",
    readTime: "5 min read",
    tags: ["OpenClaw", "Stitch", "Architecture"],
    titleTr: "OpenClaw ve Stitch ile Otonom İstemciler Kurmak",
    descriptionTr: "Akıllı kod üretimini sağlam veri pipeline'larıyla birleştirerek yüksek derecede otonom ve bağlı mobil istemciler oluşturmak.",
    slug: "openclaw-stitch-autonomous-clients"
  },
  {
    id: "personalized-ux-llm-coreml",
    title: "Designing Personalized In-App UX using LLMs and Core ML",
    description: "Using on-device context and machine learning to dynamically adapt the user interface to individual user behaviors.",
    date: "2026-03-22",
    readTime: "8 min read",
    tags: ["UX", "LLM", "Core ML"],
    titleTr: "LLM ve Core ML ile Kişiselleştirilmiş Uygulama İçi Deneyim Tasarlamak",
    descriptionTr: "Cihaz üstü bağlam ve makine öğrenmesiyle arayüzü kullanıcı davranışına göre dinamik olarak uyarlamak.",
    slug: "personalized-ux-llm-coreml"
  },
  {
    id: "swift-concurrency-in-production",
    title: "Swift Concurrency in Production: The Mistakes That Cost Us Most",
    description: "What actually breaks after the migration compiles: actor reentrancy, task lifetimes and the false comfort of a green build.",
    date: "2026-04-05",
    readTime: "9 min read",
    tags: ["Swift 6", "Concurrency", "Architecture"],
    titleTr: "Production'da Swift Concurrency: Bize En Pahalıya Mal Olan Hatalar",
    descriptionTr: "Migration derlendikten sonra asıl ne bozuluyor: actor reentrancy, task ömürleri ve yeşil bir build'in yanıltıcı rahatlığı.",
    starter: true,
    slug: "swift-concurrency-in-production"
  },
  {
    id: "swiftui-observation-redraw-cost",
    title: "Observation, State and the Real Cost of a Redraw",
    description: "How SwiftUI decides to re-evaluate a view, why it usually does it more than you expect, and how to measure it instead of guessing.",
    date: "2026-04-19",
    readTime: "8 min read",
    tags: ["SwiftUI", "Performance", "State Management"],
    titleTr: "Observation, State ve Bir Yeniden Çizimin Gerçek Maliyeti",
    descriptionTr: "SwiftUI bir view'ı yeniden değerlendirmeye nasıl karar veriyor, neden beklediğinizden sık yapıyor ve bunu tahmin etmek yerine nasıl ölçersiniz.",
    slug: "swiftui-observation-redraw-cost"
  },
  {
    id: "shared-swift-across-apple-platforms",
    title: "One Codebase, Four Platforms: Sharing Swift Without a Lowest-Common-Denominator UI",
    description: "Splitting an app so iOS, macOS, watchOS and the Vision platform share logic while each keeps an interface that belongs there.",
    date: "2026-05-10",
    readTime: "7 min read",
    tags: ["Ecosystem", "SwiftUI", "macOS"],
    titleTr: "Tek Kod Tabanı, Dört Platform: En Düşük Ortak Payda Arayüzüne Düşmeden Swift Paylaşmak",
    descriptionTr: "Uygulamayı iOS, macOS, watchOS ve uzamsal platform mantığı paylaşacak, her biri oraya ait bir arayüz koruyacak şekilde bölmek.",
    slug: "shared-swift-across-apple-platforms"
  },
  {
    id: "widgets-live-activities-glance-ux",
    title: "Designing for the Glance: Widgets and Live Activities as First-Class Surfaces",
    description: "Treating the lock screen and home screen as real product surfaces, with the update budget and failure modes that come with them.",
    date: "2026-05-24",
    readTime: "7 min read",
    tags: ["iOS", "Ecosystem", "SwiftUI"],
    titleTr: "Bir Bakışa Tasarlamak: Widget ve Live Activities Birinci Sınıf Yüzeyler Olarak",
    descriptionTr: "Kilit ekranını ve ana ekranı gerçek ürün yüzeyi saymak; beraberinde gelen güncelleme bütçesi ve hata biçimleriyle.",
    slug: "widgets-live-activities-glance-ux"
  },
  {
    id: "passkeys-banking-app-migration",
    title: "Passkeys in a Banking App: Replacing Passwords Without Losing Users",
    description: "A migration path from passwords to passkeys that survives account recovery, shared devices and customers who change phones.",
    date: "2026-06-14",
    readTime: "7 min read",
    tags: ["Security", "Biometrics", "Fintech"],
    titleTr: "Bankacılık Uygulamasında Passkey: Kullanıcı Kaybetmeden Parolayı Değiştirmek",
    descriptionTr: "Hesap kurtarma, paylaşılan cihazlar ve telefon değiştiren müşterilerle ayakta kalan bir parola-passkey geçiş yolu.",
    slug: "passkeys-banking-app-migration"
  },
  {
    id: "feature-flags-runtime-configuration",
    title: "Feature Flags Without the Mess: Runtime Configuration at Scale",
    description: "Typed flags, a single source of truth and a deletion policy, so a rollout tool does not quietly become permanent architecture.",
    date: "2026-06-28",
    readTime: "8 min read",
    tags: ["Architecture", "Modular", "Product"],
    titleTr: "Dağılmadan Feature Flag: Ölçekte Runtime Yapılandırma",
    descriptionTr: "Tipli flag'ler, tek bir doğruluk kaynağı ve silme politikası; böylece bir rollout aracı sessizce kalıcı mimariye dönüşmüyor.",
    slug: "feature-flags-runtime-configuration"
  },
  {
    id: "cutting-ci-time-caching-sharding",
    title: "Cutting CI Time in Half: Caching, Sharding and Honest Metrics",
    description: "Where mobile pipelines actually spend their minutes, and which optimisations survive contact with a busy merge queue.",
    date: "2026-07-19",
    readTime: "7 min read",
    tags: ["CI/CD", "Automation", "DevOps"],
    titleTr: "CI Süresini Yarıya İndirmek: Önbellek, Parçalama ve Dürüst Metrikler",
    descriptionTr: "Mobil pipeline'ların dakikalarını gerçekte nereye harcadığı ve hangi iyileştirmelerin yoğun bir merge kuyruğuyla temasta ayakta kaldığı.",
    slug: "cutting-ci-time-caching-sharding"
  },
  {
    id: "code-review-at-scale",
    title: "Code Review at Scale: What to Automate and What to Argue About",
    description: "Machines should own formatting and obvious defects. Humans should own boundaries, naming and whether the change should exist.",
    date: "2026-08-16",
    readTime: "8 min read",
    tags: ["Engineering Culture", "Code Quality", "Leadership"],
    titleTr: "Ölçekte Code Review: Neyi Otomatikleştirmeli, Neyi Tartışmalı",
    descriptionTr: "Makineler biçimlendirmeyi ve bariz hataları üstlenmeli. İnsanlar sınırları, isimlendirmeyi ve değişikliğin var olması gerekip gerekmediğini.",
    starter: true,
    slug: "code-review-at-scale"
  },
  {
    id: "on-device-agents-mobile",
    title: "What an On-Device Agent Can Actually Do in a Mobile App",
    description: "Separating the useful, bounded version of agentic behaviour from the demo that falls apart the moment it touches real state.",
    date: "2026-09-06",
    readTime: "9 min read",
    tags: ["AI", "On-Device AI", "Architecture"],
    titleTr: "Cihaz Üstü Bir Agent Mobil Uygulamada Gerçekte Ne Yapabilir",
    descriptionTr: "Agentic davranışın faydalı ve sınırlı hâlini, gerçek state'e dokunur dokunmaz dağılan demodan ayırmak.",
    slug: "on-device-agents-mobile"
  },
  {
    id: "writing-an-mcp-server-for-your-codebase",
    title: "Writing an MCP Server for Your Own Codebase",
    description: "Model Context Protocol turns your build system, ticket tracker and architecture rules into tools an assistant can actually use. Here is how to build one that earns its place.",
    date: "2026-09-14",
    readTime: "8 min read",
    tags: ["MCP", "AI Tooling", "Automation"],
    titleTr: "Kendi Kod Tabanınız için MCP Sunucusu Yazmak",
    descriptionTr: "Model Context Protocol, build sisteminizi, issue tracker'ınızı ve mimari kurallarınızı bir asistanın gerçekten kullanabileceği araçlara çeviriyor. Yerini hak eden bir sunucu nasıl kurulur.",
    starter: true,
    slug: "writing-an-mcp-server-for-your-codebase"
  },
  {
    id: "agentic-coding-regulated-codebase",
    title: "Agentic Coding in a Regulated Codebase: What I Let the Agent Touch",
    description: "Where autonomous coding tools genuinely help inside a fintech repository, where they must be fenced off, and how to draw that line in code rather than in policy.",
    date: "2026-09-10",
    readTime: "7 min read",
    tags: ["AI", "Code Quality", "Security"],
    titleTr: "Regüle Bir Kod Tabanında Agent'la Geliştirme: Neye Dokunmasına İzin Veriyorum",
    descriptionTr: "Otonom kod araçlarının bir fintech repository'sinde gerçekten yardımcı olduğu yerler, çitle çevrilmesi gerekenler ve bu sınırı politikayla değil kodla çizmek.",
    starter: true,
    slug: "agentic-coding-regulated-codebase"
  },
  {
    id: "foundation-models-framework-real-app",
    title: "Apple's Foundation Models Framework in a Real App",
    description: "Using the on-device language model for structured output, guided generation and tool calling, and knowing when to reach for something else entirely.",
    date: "2026-08-30",
    readTime: "8 min read",
    tags: ["Foundation Models", "Apple Intelligence", "AI"],
    titleTr: "Apple Foundation Models Framework'ü Gerçek Bir Uygulamada",
    descriptionTr: "Cihaz üstü dil modelini yapılandırılmış çıktı, guided generation ve tool calling için kullanmak; bir de ne zaman başka bir şeye uzanmak gerektiğini bilmek.",
    slug: "foundation-models-framework-real-app"
  },
  {
    id: "swift-testing-migration",
    title: "Swift Testing: Migrating a Large XCTest Suite Without Stopping the World",
    description: "Traits, parameterised tests and expressive expectations, adopted incrementally in a codebase that cannot afford a testing freeze.",
    date: "2026-08-02",
    readTime: "8 min read",
    tags: ["Swift Testing", "Testing", "Xcode"],
    titleTr: "Swift Testing: Büyük Bir XCTest Setini Dünyayı Durdurmadan Taşımak",
    descriptionTr: "Trait'ler, parametreli testler ve ifade gücü yüksek beklentiler; test dondurması kaldıramayacak bir kod tabanında kademeli olarak benimsemek.",
    slug: "swift-testing-migration"
  },
  {
    id: "swiftdata-in-production",
    title: "SwiftData in Production: What It Replaces and What It Does Not",
    description: "Where the modelling layer earns its keep, where Core Data still wins, and the migration questions to answer before the first release.",
    date: "2026-07-05",
    readTime: "8 min read",
    tags: ["SwiftData", "Persistence", "Architecture"],
    titleTr: "Production'da SwiftData: Neyin Yerine Geçer, Neyin Geçmez",
    descriptionTr: "Modelleme katmanının değerini kanıtladığı yerler, Core Data'nın hâlâ kazandığı yerler ve ilk release'ten önce cevaplanması gereken migration soruları.",
    slug: "swiftdata-in-production"
  },
  {
    id: "app-intents-scriptable-app",
    title: "App Intents: Making an App Scriptable, Searchable and Assistant-Ready",
    description: "One definition that powers Shortcuts, Spotlight, widgets and the assistant, and the modelling decisions that determine whether any of it feels good.",
    date: "2026-06-07",
    readTime: "6 min read",
    tags: ["App Intents", "iOS", "Ecosystem"],
    titleTr: "App Intents: Uygulamayı Script'lenebilir, Aranabilir ve Asistana Hazır Kılmak",
    descriptionTr: "Shortcuts, Spotlight, widget'lar ve asistanı tek bir tanımla besleyen yapı; bir de bunun iyi hissettirip hissettirmeyeceğini belirleyen modelleme kararları.",
    slug: "app-intents-scriptable-app"
  },
  {
    id: "accessibility-is-a-feature",
    title: "Accessibility Is a Feature, Not an Audit",
    description: "Building VoiceOver, Dynamic Type and reduced motion into the development loop instead of discovering them a week before submission.",
    date: "2026-05-17",
    readTime: "7 min read",
    tags: ["Accessibility", "UI/UX", "iOS"],
    titleTr: "Erişilebilirlik Bir Denetim Değil, Bir Özelliktir",
    descriptionTr: "VoiceOver, Dynamic Type ve azaltılmış hareketi geliştirme döngüsüne yerleştirmek; submit'ten bir hafta önce keşfetmek yerine.",
    slug: "accessibility-is-a-feature"
  },
  {
    id: "storekit-2-subscriptions",
    title: "StoreKit 2 and Subscriptions Without the Guesswork",
    description: "Transaction listeners, server notifications and the entitlement model that keeps paying customers from losing access at the worst moment.",
    date: "2026-04-26",
    readTime: "6 min read",
    tags: ["StoreKit", "Product", "Indie Dev"],
    titleTr: "StoreKit 2 ve Tahmine Dayanmayan Abonelikler",
    descriptionTr: "Transaction listener'lar, sunucu bildirimleri ve ödeme yapan müşterinin en kötü anda erişimini kaybetmesini önleyen entitlement modeli.",
    slug: "storekit-2-subscriptions"
  },
  {
    id: "xcode-cloud-vs-self-hosted-ci",
    title: "Xcode Cloud or Self-Hosted CI: Choosing Without Regret",
    description: "A comparison based on what actually costs time and money in mobile delivery, rather than on feature checklists.",
    date: "2026-04-12",
    readTime: "5 min read",
    tags: ["Xcode Cloud", "CI/CD", "DevOps"],
    titleTr: "Xcode Cloud mu, Kendi CI'ınız mı: Pişman Olmadan Seçmek",
    descriptionTr: "Özellik listesine göre değil, mobil teslimatta gerçekten zaman ve para harcayan şeylere göre bir karşılaştırma.",
    slug: "xcode-cloud-vs-self-hosted-ci"
  },
  {
    id: "dalga-app-store-case-study",
    title: "Dalga: From Idea to App Store Review (Case Study)",
    description: "How a quit-smoking app was planned, built, set up in App Store Connect and taken through its first App Review round. Written in Turkish.",
    date: "2026-10-31",
    readTime: "16 min read",
    tags: ["Indie Dev", "ASO", "StoreKit", "Product"],
    titleTr: "Dalga: Fikirden App Store İncelemesine (Vaka Çalışması)",
    descriptionTr: "Bir sigara bırakma uygulamasının nasıl planlandığı, yapıldığı, App Store Connect'te kurulduğu ve ilk inceleme turundan geçtiği.",
    slug: "dalga-app-store-vaka-calismasi",
    bodyLang: "tr"
  },
  {
    id: "app-shipping-playbook",
    title: "Shipping an App: The Full Process from Idea to App Store and Beyond",
    description: "A reusable playbook: research, design references, App Store Connect setup, metadata and ASO, store assets, analytics, App Review and marketing. Written in Turkish.",
    date: "2026-10-31",
    readTime: "14 min read",
    tags: ["Indie Dev", "ASO", "Marketing", "Product"],
    titleTr: "Genel Süreç: Fikirden App Store'a ve Sonrasına",
    descriptionTr: "Her uygulamada izlenecek yol: araştırma, tasarım referansları, App Store Connect, metadata ve ASO, mağaza görselleri, analitik, App Review ve pazarlama.",
    slug: "uygulama-yayin-rehberi",
    bodyLang: "tr"
  }
].sort((a, b) => new Date(b.date) - new Date(a.date));

export const allTags = [...new Set(articles.flatMap((a) => a.tags))];

/**
 * A short curated entry point for someone facing 52 articles for the first
 * time. Order follows the array, newest first.
 */
export const starterArticles = articles.filter((a) => a.starter);

/**
 * Articles closest to the given one, ranked by shared tags and then by
 * recency. Used at the end of a post so a reader has somewhere to go.
 */
export const relatedArticles = (article, limit = 3) => {
  if (!article) return [];
  const tags = new Set(article.tags || []);

  return articles
    .filter((a) => a.slug !== article.slug)
    .map((a) => ({
      article: a,
      score: (a.tags || []).filter((t) => tags.has(t)).length,
    }))
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score || new Date(b.article.date) - new Date(a.article.date))
    .slice(0, limit)
    .map((entry) => entry.article);
};
